module.exports = "<div class=\"message-form__inner\">\n  <form name=\"messageForm\" class=\"message-form__form\" ng-submit=\"$ctrl.handleSubmit($event)\">\n    <textarea ng-model=\"$ctrl.message.body\" msd-elastic rows=\"1\" class=\"message-form__input\" placeholder=\"Say something\"></textarea>\n    <input type=\"submit\" class=\"message-form__submit\" value=\"\">\n  </form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/dashboard/components/message-form/message-form.html
// module id = 314
// module chunks = 0